const closeButtonLabel = "Κλείσιμο";
const elCY = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  elCY as default
};
